

































import { Component, Vue } from 'vue-property-decorator'
import { EFriend, friends } from '@/types/categories/friend'
import CategoryMedia from '@/components/media/CategoryMedia.vue'
import FriendList from '@/components/FriendList.vue'
import BackButton from '@/components/BackButton.vue'
import LevelOptions from '@/components/LevelOptions.vue'

@Component({
  components: {
    FriendList,
    LevelOptions,
    CategoryMedia,
    BackButton
  }
})
export default class FriendSelector extends Vue {
  protected friends: Array<EFriend> = friends
  protected friend: EFriend = EFriend.Alice
  protected level: Number = 7

  get selectedFriend () {
    return this.$store.getters['selectedFriend']
  }

  get selectedPresent () {
    return this.$store.getters['selectedPresent']
  }

  protected onFriendClicked (friend: EFriend) {
    this.friend = friend
  }

  protected onLevelClicked (level: Number) {
    this.level = level
  }

  protected onStartClicked () {
    this.$store.dispatch('init', {
      selectedFriend: this.friend,
      selectedLevel: this.level
    })
  }
}
